<script setup>
import BaseModal from "../../global/modals/BaseModal.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import BlogContentGeneration from "../BlogContentGeneration.vue";

const store = useStore()

const modalOpen = computed(() => store.getters['blogGeneration/modalOpen']);
const closeModal = () => {
  store.dispatch('blogGeneration/closeModal');
  const scrapboardEvent = new Event('open-scrapboard');
  window.dispatchEvent(scrapboardEvent);
}
</script>

<template>
  <div>
    <BaseModal
      v-if="modalOpen"
      :hide-close-button="true"
      @close="closeModal"
    >
      <BlogContentGeneration />
    </BaseModal>
  </div>
</template>
